export default __webpack_public_path__ + "static/media/svg-10.193c27ae.svg";